import { lazy } from 'react'

export const ReactQueryDevtools = import.meta.env.PROD
  ? (): null => null
  : lazy(() => import('@tanstack/react-query-devtools').then((value) => ({ default: value.ReactQueryDevtools })))
